// language=GraphQL
export const ALL_TEXT_WITH_IMAGE_BLOCKS_QUERY = `query Query($withImage: Boolean = false, $withGallery: Boolean = false, $withGalleryImages: Boolean = false, $withLink: Boolean = false, $withLinkPage: Boolean = false, $withLinkPageSeoSettings: Boolean = false, $withLinkPageContentBlockAssignments: Boolean = false, $withLinkTravel: Boolean = false, $withLinkTravelAvailabilityStatus: Boolean = false, $withLinkTravelTravelConsultant: Boolean = false, $withLinkTravelLabel: Boolean = false, $withLinkTravelSeoSettings: Boolean = false, $withLinkTravelTenantSettings: Boolean = false, $withLinkTravelHighlights: Boolean = false, $withLinkTravelPartners: Boolean = false, $withLinkTravelTravelGuides: Boolean = false, $withLinkTravelTeams: Boolean = false, $withLinkTravelAccommodationAssignments: Boolean = false, $withLinkTravelAccommodations: Boolean = false, $withLinkTravelDestinations: Boolean = false, $withLinkTravelTestimonials: Boolean = false, $withLinkTravelMainImage: Boolean = false, $withLinkTravelMainVideo: Boolean = false, $withLinkTravelGallery: Boolean = false, $withLinkTravelTravelPdf: Boolean = false, $withLinkTravelTravelExtensions: Boolean = false, $withLinkTravelItinerary: Boolean = false, $withLinkTravelPricing: Boolean = false, $withLinkTravelFaqs: Boolean = false) {
  textWithImageBlocks: cmsTextWithImageBlocks {
    id
    title
    subtitle
    text
    imagePosition
    image @include(if: $withImage) {
      id
      assetId
      publicId
      url
      resourceType
      format
      width
      height
      caption
      title
      description
    }
    imageFixedAspectRatio
    gallery @include(if: $withGallery) {
      id
      images @include(if: $withGalleryImages) {
        id
        assetId
        publicId
        url
        resourceType
        format
        width
        height
        caption
        title
        description
      }
    }
    link @include(if: $withLink) {
      id
      label
      targetBlank
      type
      url
      page @include(if: $withLinkPage) {
        id
        name
        onlineStatus
        seoSettings @include(if: $withLinkPageSeoSettings) {
          id
          urlSlug
          metaTitle
          metaDescription
          ogTitle
          ogDescription
        }
        contentBlockAssignments @include(if: $withLinkPageContentBlockAssignments) {
          id
          type
        }
      }
      travel @include(if: $withLinkTravel) {
        id
        name
        isBestseller
        startDate
        endDate
        availabilityStatus @include(if: $withLinkTravelAvailabilityStatus) {
          id
          label
          status
          isDefaultStatus
          isDefaultWaitlistFallback
        }
        executionStatus
        travelConsultant @include(if: $withLinkTravelTravelConsultant) {
          id
          firstName
          lastName
          jobTitle
          description
          email
          phone
        }
        label @include(if: $withLinkTravelLabel) {
          id
          label
        }
        title
        description
        introVideoUrl
        includedServices
        excludedServices
        pricingTable
        priceCalculationInfo
        seoSettings @include(if: $withLinkTravelSeoSettings) {
          id
          urlSlug
          metaTitle
          metaDescription
          ogTitle
          ogDescription
        }
        tenantSettings @include(if: $withLinkTravelTenantSettings) {
          id
          onlineStatus
          redirectToBooking
          useTiming
          startDate
          endDate
        }
        highlights @include(if: $withLinkTravelHighlights) {
          id
          text
        }
        partners @include(if: $withLinkTravelPartners) {
          id
          name
          url
          logoWidth
        }
        travelGuides @include(if: $withLinkTravelTravelGuides) {
          id
          firstName
          lastName
          description
        }
        teams @include(if: $withLinkTravelTeams) {
          id
          name
        }
        accommodationAssignments @include(if: $withLinkTravelAccommodationAssignments) {
          id
          useCustomRoomTypeSelection
          displayDetails
        }
        accommodations @include(if: $withLinkTravelAccommodations) {
          id
          label
          name
          stars
          description
        }
        destinations @include(if: $withLinkTravelDestinations) {
          id
          name
          entryRequirements
          medicalInformation
          language
          timeShift
          climate
          currency
        }
        testimonials @include(if: $withLinkTravelTestimonials) {
          id
        }
        mainImage @include(if: $withLinkTravelMainImage) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
        mainVideo @include(if: $withLinkTravelMainVideo) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
        gallery @include(if: $withLinkTravelGallery) {
          id
        }
        travelPdf @include(if: $withLinkTravelTravelPdf) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
        travelExtensions @include(if: $withLinkTravelTravelExtensions) {
          id
          duration
          name
          description
        }
        programType
        itinerary @include(if: $withLinkTravelItinerary) {
          id
        }
        programText
        pricing @include(if: $withLinkTravelPricing) {
          id
          isTravelDocumentationAvailable
        }
        minPrice
        minPriceManualOverride
        currency
        faqs @include(if: $withLinkTravelFaqs) {
          id
          question
          answer
        }
      }
    }
  }
}`

// language=GraphQL
export const SINGLE_TEXT_WITH_IMAGE_BLOCK_QUERY = `query Query($id: ID!, $withImage: Boolean = false, $withGallery: Boolean = false, $withGalleryImages: Boolean = false, $withLink: Boolean = false, $withLinkPage: Boolean = false, $withLinkPageSeoSettings: Boolean = false, $withLinkPageContentBlockAssignments: Boolean = false, $withLinkTravel: Boolean = false, $withLinkTravelAvailabilityStatus: Boolean = false, $withLinkTravelTravelConsultant: Boolean = false, $withLinkTravelLabel: Boolean = false, $withLinkTravelSeoSettings: Boolean = false, $withLinkTravelTenantSettings: Boolean = false, $withLinkTravelHighlights: Boolean = false, $withLinkTravelPartners: Boolean = false, $withLinkTravelTravelGuides: Boolean = false, $withLinkTravelTeams: Boolean = false, $withLinkTravelAccommodationAssignments: Boolean = false, $withLinkTravelAccommodations: Boolean = false, $withLinkTravelDestinations: Boolean = false, $withLinkTravelTestimonials: Boolean = false, $withLinkTravelMainImage: Boolean = false, $withLinkTravelMainVideo: Boolean = false, $withLinkTravelGallery: Boolean = false, $withLinkTravelTravelPdf: Boolean = false, $withLinkTravelTravelExtensions: Boolean = false, $withLinkTravelItinerary: Boolean = false, $withLinkTravelPricing: Boolean = false, $withLinkTravelFaqs: Boolean = false) {
  textWithImageBlock: cmsTextWithImageBlock(id: $id) {
    id
    title
    subtitle
    text
    imagePosition
    image @include(if: $withImage) {
      id
      assetId
      publicId
      url
      resourceType
      format
      width
      height
      caption
      title
      description
    }
    imageFixedAspectRatio
    gallery @include(if: $withGallery) {
      id
      images @include(if: $withGalleryImages) {
        id
        assetId
        publicId
        url
        resourceType
        format
        width
        height
        caption
        title
        description
      }
    }
    link @include(if: $withLink) {
      id
      label
      targetBlank
      type
      url
      page @include(if: $withLinkPage) {
        id
        name
        onlineStatus
        seoSettings @include(if: $withLinkPageSeoSettings) {
          id
          urlSlug
          metaTitle
          metaDescription
          ogTitle
          ogDescription
        }
        contentBlockAssignments @include(if: $withLinkPageContentBlockAssignments) {
          id
          type
        }
      }
      travel @include(if: $withLinkTravel) {
        id
        name
        isBestseller
        startDate
        endDate
        availabilityStatus @include(if: $withLinkTravelAvailabilityStatus) {
          id
          label
          status
          isDefaultStatus
          isDefaultWaitlistFallback
        }
        executionStatus
        travelConsultant @include(if: $withLinkTravelTravelConsultant) {
          id
          firstName
          lastName
          jobTitle
          description
          email
          phone
        }
        label @include(if: $withLinkTravelLabel) {
          id
          label
        }
        title
        description
        introVideoUrl
        includedServices
        excludedServices
        pricingTable
        priceCalculationInfo
        seoSettings @include(if: $withLinkTravelSeoSettings) {
          id
          urlSlug
          metaTitle
          metaDescription
          ogTitle
          ogDescription
        }
        tenantSettings @include(if: $withLinkTravelTenantSettings) {
          id
          onlineStatus
          redirectToBooking
          useTiming
          startDate
          endDate
        }
        highlights @include(if: $withLinkTravelHighlights) {
          id
          text
        }
        partners @include(if: $withLinkTravelPartners) {
          id
          name
          url
          logoWidth
        }
        travelGuides @include(if: $withLinkTravelTravelGuides) {
          id
          firstName
          lastName
          description
        }
        teams @include(if: $withLinkTravelTeams) {
          id
          name
        }
        accommodationAssignments @include(if: $withLinkTravelAccommodationAssignments) {
          id
          useCustomRoomTypeSelection
          displayDetails
        }
        accommodations @include(if: $withLinkTravelAccommodations) {
          id
          label
          name
          stars
          description
        }
        destinations @include(if: $withLinkTravelDestinations) {
          id
          name
          entryRequirements
          medicalInformation
          language
          timeShift
          climate
          currency
        }
        testimonials @include(if: $withLinkTravelTestimonials) {
          id
        }
        mainImage @include(if: $withLinkTravelMainImage) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
        mainVideo @include(if: $withLinkTravelMainVideo) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
        gallery @include(if: $withLinkTravelGallery) {
          id
        }
        travelPdf @include(if: $withLinkTravelTravelPdf) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
        travelExtensions @include(if: $withLinkTravelTravelExtensions) {
          id
          duration
          name
          description
        }
        programType
        itinerary @include(if: $withLinkTravelItinerary) {
          id
        }
        programText
        pricing @include(if: $withLinkTravelPricing) {
          id
          isTravelDocumentationAvailable
        }
        minPrice
        minPriceManualOverride
        currency
        faqs @include(if: $withLinkTravelFaqs) {
          id
          question
          answer
        }
      }
    }
  }
}`

// language=GraphQL
export const CREATE_TEXT_WITH_IMAGE_BLOCK_MUTATION = `
  mutation Mutation($input: CreateCmsTextWithImageBlockInput, $withImage: Boolean = false, $withGallery: Boolean = false, $withGalleryImages: Boolean = false, $withLink: Boolean = false, $withLinkPage: Boolean = false, $withLinkPageSeoSettings: Boolean = false, $withLinkPageContentBlockAssignments: Boolean = false, $withLinkTravel: Boolean = false, $withLinkTravelAvailabilityStatus: Boolean = false, $withLinkTravelTravelConsultant: Boolean = false, $withLinkTravelLabel: Boolean = false, $withLinkTravelSeoSettings: Boolean = false, $withLinkTravelTenantSettings: Boolean = false, $withLinkTravelHighlights: Boolean = false, $withLinkTravelPartners: Boolean = false, $withLinkTravelTravelGuides: Boolean = false, $withLinkTravelTeams: Boolean = false, $withLinkTravelAccommodationAssignments: Boolean = false, $withLinkTravelAccommodations: Boolean = false, $withLinkTravelDestinations: Boolean = false, $withLinkTravelTestimonials: Boolean = false, $withLinkTravelMainImage: Boolean = false, $withLinkTravelMainVideo: Boolean = false, $withLinkTravelGallery: Boolean = false, $withLinkTravelTravelPdf: Boolean = false, $withLinkTravelTravelExtensions: Boolean = false, $withLinkTravelItinerary: Boolean = false, $withLinkTravelPricing: Boolean = false, $withLinkTravelFaqs: Boolean = false) {
    textWithImageBlock: createCmsTextWithImageBlock(input: $input) {
      id
      title
      subtitle
      text
      imagePosition
      image @include(if: $withImage) {
        id
        assetId
        publicId
        url
        resourceType
        format
        width
        height
        caption
        title
        description
      }
      imageFixedAspectRatio
      gallery @include(if: $withGallery) {
        id
        images @include(if: $withGalleryImages) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
      }
      link @include(if: $withLink) {
        id
        label
        targetBlank
        type
        url
        page @include(if: $withLinkPage) {
          id
          name
          onlineStatus
          seoSettings @include(if: $withLinkPageSeoSettings) {
            id
            urlSlug
            metaTitle
            metaDescription
            ogTitle
            ogDescription
          }
          contentBlockAssignments @include(if: $withLinkPageContentBlockAssignments) {
            id
            type
          }
        }
        travel @include(if: $withLinkTravel) {
          id
          name
          isBestseller
          startDate
          endDate
          availabilityStatus @include(if: $withLinkTravelAvailabilityStatus) {
            id
            label
            status
            isDefaultStatus
            isDefaultWaitlistFallback
          }
          executionStatus
          travelConsultant @include(if: $withLinkTravelTravelConsultant) {
            id
            firstName
            lastName
            jobTitle
            description
            email
            phone
          }
          label @include(if: $withLinkTravelLabel) {
            id
            label
          }
          title
          description
          introVideoUrl
          includedServices
          excludedServices
          pricingTable
          priceCalculationInfo
          seoSettings @include(if: $withLinkTravelSeoSettings) {
            id
            urlSlug
            metaTitle
            metaDescription
            ogTitle
            ogDescription
          }
          tenantSettings @include(if: $withLinkTravelTenantSettings) {
            id
            onlineStatus
            redirectToBooking
            useTiming
            startDate
            endDate
          }
          highlights @include(if: $withLinkTravelHighlights) {
            id
            text
          }
          partners @include(if: $withLinkTravelPartners) {
            id
            name
            url
            logoWidth
          }
          travelGuides @include(if: $withLinkTravelTravelGuides) {
            id
            firstName
            lastName
            description
          }
          teams @include(if: $withLinkTravelTeams) {
            id
            name
          }
          accommodationAssignments @include(if: $withLinkTravelAccommodationAssignments) {
            id
            useCustomRoomTypeSelection
            displayDetails
          }
          accommodations @include(if: $withLinkTravelAccommodations) {
            id
            label
            name
            stars
            description
          }
          destinations @include(if: $withLinkTravelDestinations) {
            id
            name
            entryRequirements
            medicalInformation
            language
            timeShift
            climate
            currency
          }
          testimonials @include(if: $withLinkTravelTestimonials) {
            id
          }
          mainImage @include(if: $withLinkTravelMainImage) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
          mainVideo @include(if: $withLinkTravelMainVideo) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
          gallery @include(if: $withLinkTravelGallery) {
            id
          }
          travelPdf @include(if: $withLinkTravelTravelPdf) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
          travelExtensions @include(if: $withLinkTravelTravelExtensions) {
            id
            duration
            name
            description
          }
          programType
          itinerary @include(if: $withLinkTravelItinerary) {
            id
          }
          programText
          pricing @include(if: $withLinkTravelPricing) {
            id
            isTravelDocumentationAvailable
          }
          minPrice
          minPriceManualOverride
          currency
          faqs @include(if: $withLinkTravelFaqs) {
            id
            question
            answer
          }
        }
      }
    }
  }`

// language=GraphQL
export const UPDATE_TEXT_WITH_IMAGE_BLOCK_MUTATION = `
  mutation Mutation($input: UpdateCmsTextWithImageBlockInput, $withImage: Boolean = false, $withGallery: Boolean = false, $withGalleryImages: Boolean = false, $withLink: Boolean = false, $withLinkPage: Boolean = false, $withLinkPageSeoSettings: Boolean = false, $withLinkPageContentBlockAssignments: Boolean = false, $withLinkTravel: Boolean = false, $withLinkTravelAvailabilityStatus: Boolean = false, $withLinkTravelTravelConsultant: Boolean = false, $withLinkTravelLabel: Boolean = false, $withLinkTravelSeoSettings: Boolean = false, $withLinkTravelTenantSettings: Boolean = false, $withLinkTravelHighlights: Boolean = false, $withLinkTravelPartners: Boolean = false, $withLinkTravelTravelGuides: Boolean = false, $withLinkTravelTeams: Boolean = false, $withLinkTravelAccommodationAssignments: Boolean = false, $withLinkTravelAccommodations: Boolean = false, $withLinkTravelDestinations: Boolean = false, $withLinkTravelTestimonials: Boolean = false, $withLinkTravelMainImage: Boolean = false, $withLinkTravelMainVideo: Boolean = false, $withLinkTravelGallery: Boolean = false, $withLinkTravelTravelPdf: Boolean = false, $withLinkTravelTravelExtensions: Boolean = false, $withLinkTravelItinerary: Boolean = false, $withLinkTravelPricing: Boolean = false, $withLinkTravelFaqs: Boolean = false) {
    textWithImageBlock: updateCmsTextWithImageBlock(input: $input) {
      id
      title
      subtitle
      text
      imagePosition
      image @include(if: $withImage) {
        id
        assetId
        publicId
        url
        resourceType
        format
        width
        height
        caption
        title
        description
      }
      imageFixedAspectRatio
      gallery @include(if: $withGallery) {
        id
        images @include(if: $withGalleryImages) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
      }
      link @include(if: $withLink) {
        id
        label
        targetBlank
        type
        url
        page @include(if: $withLinkPage) {
          id
          name
          onlineStatus
          seoSettings @include(if: $withLinkPageSeoSettings) {
            id
            urlSlug
            metaTitle
            metaDescription
            ogTitle
            ogDescription
          }
          contentBlockAssignments @include(if: $withLinkPageContentBlockAssignments) {
            id
            type
          }
        }
        travel @include(if: $withLinkTravel) {
          id
          name
          isBestseller
          startDate
          endDate
          availabilityStatus @include(if: $withLinkTravelAvailabilityStatus) {
            id
            label
            status
            isDefaultStatus
            isDefaultWaitlistFallback
          }
          executionStatus
          travelConsultant @include(if: $withLinkTravelTravelConsultant) {
            id
            firstName
            lastName
            jobTitle
            description
            email
            phone
          }
          label @include(if: $withLinkTravelLabel) {
            id
            label
          }
          title
          description
          introVideoUrl
          includedServices
          excludedServices
          pricingTable
          priceCalculationInfo
          seoSettings @include(if: $withLinkTravelSeoSettings) {
            id
            urlSlug
            metaTitle
            metaDescription
            ogTitle
            ogDescription
          }
          tenantSettings @include(if: $withLinkTravelTenantSettings) {
            id
            onlineStatus
            redirectToBooking
            useTiming
            startDate
            endDate
          }
          highlights @include(if: $withLinkTravelHighlights) {
            id
            text
          }
          partners @include(if: $withLinkTravelPartners) {
            id
            name
            url
            logoWidth
          }
          travelGuides @include(if: $withLinkTravelTravelGuides) {
            id
            firstName
            lastName
            description
          }
          teams @include(if: $withLinkTravelTeams) {
            id
            name
          }
          accommodationAssignments @include(if: $withLinkTravelAccommodationAssignments) {
            id
            useCustomRoomTypeSelection
            displayDetails
          }
          accommodations @include(if: $withLinkTravelAccommodations) {
            id
            label
            name
            stars
            description
          }
          destinations @include(if: $withLinkTravelDestinations) {
            id
            name
            entryRequirements
            medicalInformation
            language
            timeShift
            climate
            currency
          }
          testimonials @include(if: $withLinkTravelTestimonials) {
            id
          }
          mainImage @include(if: $withLinkTravelMainImage) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
          mainVideo @include(if: $withLinkTravelMainVideo) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
          gallery @include(if: $withLinkTravelGallery) {
            id
          }
          travelPdf @include(if: $withLinkTravelTravelPdf) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
          travelExtensions @include(if: $withLinkTravelTravelExtensions) {
            id
            duration
            name
            description
          }
          programType
          itinerary @include(if: $withLinkTravelItinerary) {
            id
          }
          programText
          pricing @include(if: $withLinkTravelPricing) {
            id
            isTravelDocumentationAvailable
          }
          minPrice
          minPriceManualOverride
          currency
          faqs @include(if: $withLinkTravelFaqs) {
            id
            question
            answer
          }
        }
      }
    }
  }`

// language=GraphQL
export const DELETE_TEXT_WITH_IMAGE_BLOCK_MUTATION = `
  mutation Mutation($input: DeleteCmsTextWithImageBlockInput) {
    deleteCmsTextWithImageBlock(input: $input) {
      success
    }
  }`

// language=GraphQL
export const FORCE_DELETE_TEXT_WITH_IMAGE_BLOCK_MUTATION = `
  mutation Mutation($input: DeleteCmsTextWithImageBlockInput) {
    forceDeleteCmsTextWithImageBlock(input: $input) {
      success
    }
  }`
// language=GraphQL
export const TEXT_WITH_IMAGE_BLOCKS_DEPENDENTS_QUERY = `query Query($id: ID!, $withCmsContentBlockAssignments: Boolean = false) {
  groupedDependents: cmsTextWithImageBlockDependents(id: $id) {
    cmsContentBlockAssignments @include(if: $withCmsContentBlockAssignments) {
      id
      type
    }
  }
}`
